import { render, staticRenderFns } from "./AddJciForms.vue?vue&type=template&id=3f83f5ee"
import script from "./AddJciForms.vue?vue&type=script&lang=js"
export * from "./AddJciForms.vue?vue&type=script&lang=js"
import style0 from "./AddJciForms.vue?vue&type=style&index=0&id=3f83f5ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports